<template>
  <div class="header">
    <p class="title">{{ title }}</p>
    <div class="bar"></div>
  </div>
</template>

<script>
export default {
  name: 'LayoutHeaderTitle',
  props: {
    title: String,
  },
};
</script>

<style lang="scss" scoped>
.header {
  padding: 48px 20px 0;
  box-sizing: border-box;

  .title{
    width: 100%;
    text-align: left;
    font-size: 20px;
    margin: 0;
  }

  .bar {
    width: 100%;
    height: 1px;
    margin-top: 12px;
    background-color: #dddddd;
  }
}

@media screen and (max-width: 1024px) {
  .header {
    width: 100%;
    padding: 24px 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutHeaderTitle.vue